import React, { useState } from "react";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import moment from "moment";
import { BiCalendarAlt } from "react-icons/bi";
import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Collapse,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";

import Select from "react-select";
import { baseUrl } from "../../../utils/constants";
import { isMobile } from "../../../utils/deviceInfo";

export default function ReminderComponent({
  planType,
  remindMeDdData,
  trivia,
  resultId,
  fullWidth,
  externalUser,
  btnText
}) {
  const [remindMeOpen, setRemindMeOpen] = useState(false);

  const [selectedRemindQuestions, setSelectedRemindQuestions] = useState([]);
  console.log("extt", externalUser);
  const getRemindQuestionsDesc = () => {
    const link = externalUser
      ? `${baseUrl()}home/trivia/${trivia.organizationId}/quiz/${
          trivia._id
        }/result?resultId=${resultId}`
      : `${baseUrl()}home/trivia/${
          trivia.organizationId
        }/my-trivia?myDocId=${resultId}`;
    let text = `Trivia : ${trivia.name} \n\n `;

    for (const obj of selectedRemindQuestions) {
      text += `Question : ${obj.label} \n Correct Answer : ${obj.correctOption} \n Selected Answer : ${obj.answer}\n\n `;
    }

    text += `\n My Results Link: ${link};`;

    if (trivia.uploadUrl) {
      text += `\n Source Link: ${trivia.uploadUrl} `;
    }

    return text;
  };

  const addRemindMe = () => {
    const array = selectedRemindQuestions.map(x => {
      return {
        question_id: x.q_id,
        number: x.value + 1,
      };
    });

    axios
      .post(url.addRemindMeToTrivvyResult, {
        id: resultId,
        remindMeData: array,
      })
      .then(res => {
        console.log(res.data.data);
      })
      .catch(err => {
        console.log(err);
      });
  };
  return (
    <div
      style={{
        width: fullWidth || isMobile ? "100%" : "40%",
        margin: fullWidth ? "auto" : null,
      }}
    >
      <div className={`my-3 text-left`}>
        {planType != "001" ? (
          <Button
            onClick={() => setRemindMeOpen(!remindMeOpen)}
            className={`trivia-action-button-main create-trivvy-btn-itm ${fullWidth ? "w-100" : ""}`}
          >
        {btnText || "Reinforce your learning" }   
          </Button>
        ) : (
          <Alert color="info">
            <div className="mb-2">
              Please upgrade your package to gain access to the following
              feature.
            </div>
            <Button className="trivia-action-button-main w-100" disabled>
            {btnText || "Reinforce your learning"} 
            </Button>
          </Alert>
        )}

        <Collapse className="mt-3 text-left" isOpen={remindMeOpen}>
          <Select
            isMulti
            multi
            value={selectedRemindQuestions}
            onChange={value => setSelectedRemindQuestions(value)}
            options={remindMeDdData}
          />

          <div className="mt-3">
            <Button
              disabled={selectedRemindQuestions.length == 0}
              onClick={() => {
                addRemindMe();
                const endDate = new Date();
                endDate.setFullYear(endDate.getFullYear() + 1);
                window.atcb_action({
                  name: trivia.name,
                  description: getRemindQuestionsDesc(),
                  startDate: moment().format("YYYY-MM-DD"),
                  recurrence: "daily",
                  recurrenceInterval: 1,
                  endDate: moment(endDate).format("YYYY-MM-DD"),
                  timeZone: "currentBrowser",
                  options: [
                    "Apple",
                    "Google",
                    "iCal",
                    "Microsoft365",
                    "Outlook.com",
                    "Yahoo",
                  ],
                  label: "Add to Calendar",
                  iCalFileName: trivia.name.replace(/\s/g, ""),
                });
              }}
              className={"trivvy-add-to-calendar-questions mb-5"}
            >
              Add to Calendar <BiCalendarAlt className="ml-1" size={15} />
            </Button>
          </div>
        </Collapse>
      </div>
    </div>
  );
}
